// HTML entity map - defined outside function for better performance
import {PrefillFiltersProps} from "../types/travel.ts";

const HTML_ENTITY_MAP: Record<string, string> = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'",
    '&nbsp;': ' '
}

// Performant HTML entity decoding
export const decodeHtmlEntities = (text: string): string => {
    return text.replace(/&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-f]{1,6});/gi, (entity) => {
        return HTML_ENTITY_MAP[entity.toLowerCase()] || entity
    })
}

// Helper function to check if a section should be shown based on prefillFilters
export const getSectionVisibilityClass = (section: string, prefillFilters?: PrefillFiltersProps): string => {
    if (prefillFilters && prefillFilters[section as keyof typeof prefillFilters]) {
        const shouldShow = prefillFilters[section as keyof typeof prefillFilters]?.show
        if (shouldShow === false) {
            return 'hidden'
        }
    }
    return ''
}